var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('card-item',{attrs:{"card":"item_work","tabs":_vm.tabs,"activeTab":_vm.activeTab,"id":_vm.id}})}
var staticRenderFns = []

export { render, staticRenderFns }